import { REG_PHONE_10_DIGITS, REG_PHONE_11_DIGITS } from "kz-ui-sdk";
import { z } from "zod";

export const ValidatorSchema = {
  username: z
    .string()
    .min(4, "4-13 alphanumeric without special character.")
    .max(13, "4-13 alphanumeric without special character.")
    .regex(/^\w+$/, "only letters, numbers, and underscores (_) are allowed."),
  password: z.string().min(8, "at least 8 characters with letters & numbers"),
  phone10Digits: z
    .string()
    .regex(/^0/, "phone number should start with 0")
    .regex(REG_PHONE_10_DIGITS, "Phone number must be 10 digits"),
  phone11Digits: z
    .string()
    .regex(/^0/, "enter a 11-digit number starting with 0")
    .regex(REG_PHONE_11_DIGITS, "enter a 11-digit number starting with 0"),
  otp: z.string().min(1, "otp is required. click on get code"),
  legalName: z.string().min(1, "required"),
};
